'use client';

import { c as _c } from "react/compiler-runtime";
import { Tab } from '@common/components';
import { useCustomRouter } from '@/hooks/useCustomRouter';
export enum FILTER_PAGE {
  BASIC = 'basic',
  INTEREST = 'interest',
}
interface FilterTabProps {
  filterPage?: FILTER_PAGE;
}
export const FilterTab = t0 => {
  const $ = _c(7);
  const {
    filterPage
  } = t0;
  const router = useCustomRouter();
  const activeValue = filterPage || FILTER_PAGE.BASIC;
  let t1;
  if ($[0] !== router) {
    t1 = value => {
      router.replace(`?page=${value}`);
    };
    $[0] = router;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleTabChange = t1;
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Tab.Item value={FILTER_PAGE.BASIC}>맞춤 정보</Tab.Item>;
    t3 = <Tab.Item value={FILTER_PAGE.INTEREST}>관심 분야</Tab.Item>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== activeValue || $[5] !== handleTabChange) {
    t4 = <Tab value={activeValue} onChange={handleTabChange}>{t2}{t3}</Tab>;
    $[4] = activeValue;
    $[5] = handleTabChange;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};